import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './BacktestCta.css';

const LINKEDIN_URL = 'https://www.linkedin.com/in/sven-pfl%C3%BCger-4b01bb256/';

const BacktestCta = () => {
  const { t } = useLanguage();
  const cta = t.backtestCta;

  return (
    <section className="backtest-cta" aria-label={cta.ariaLabel}>
      <div className="backtest-cta-inner">
        <div className="backtest-cta-copy">
          <h2>{cta.title}</h2>
          <p>{cta.description}</p>
          <p className="backtest-cta-note">{cta.availability}</p>
        </div>
        <a
          className="backtest-cta-button"
          href={LINKEDIN_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          {cta.button}
        </a>
      </div>
    </section>
  );
};

export default BacktestCta;
